import styled from "styled-components";
import { theme } from "../../styles/theme";

export const LoginWrapper = styled.div`
  width: 100vw;
  height: 100vh;
  background-color: ${theme.colors.gray.Cinza_1};
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;



  @media only screen and (max-width: 820px) {
    height: calc(100vh + 100px);
    background-color: ${theme.colors.gray.Cinza_1};
    flex-direction: column;
    justify-content: flex-start;
    padding-top: 30px;

  }

  /* @media only screen and (max-height: 568px) {
    height: auto;
  } */
  
  
`;

export const Container = styled.div`
    width: 100%;
    height: auto;

    background-color: #292E38;
`;

export const Wrapper = styled.div`
    width: 100%;
    height: 100vh;
    padding: 0 1.5rem;

    gap: 10rem;
    display: flex;
    align-items: center;
    justify-content: center;

    @media (max-width: 767px) {
        overflow: auto;
        
        padding: 0 1.5rem 5rem;

        gap: 3rem;
        flex-direction: column;
        justify-content: flex-start;
    }

    @media (max-width: 478px) {
        gap: 2rem;
    }
`;

export const Description = styled.div`
    width: 100%;
    height: auto;
    max-width: 20.75rem;

    gap: 3rem;
    display: flex;
    flex-direction: column;
    align-items: flex-start;

    >img{
        width: auto;
        height: 2rem;
    }

    @media (max-width: 767px) {
        margin-top: 5rem;
        align-items: center;
    }
`;

export const Col2 = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

`;


export const DescriptionText = styled.div`
    width: 100%;
    height: auto;

    gap: 1rem;
    display: flex;
    flex-direction: column;

    >h3, >p{
        text-align: left;
    }

    @media (max-width: 767px) {
        gap: 0.75rem;
        align-items: center;

        >h3{
            font-size: 1.75rem;
            line-height: 1.75rem;
        }

        >p{
            font-size: 1rem;
            line-height: 1rem;
        }
    }

    @media (max-width: 478px) {
        gap: 0.5rem;

        >h3{
            font-size: 1.375rem;
            line-height: 1.375rem;
        }

        >p{
            font-size: 0.875rem;
            line-height: 0.875rem;
        }
    }
`;

export const Form = styled.div`
    width: 100%;
    height: auto;
    padding: 2rem;
    max-width: 30.25rem;

    gap: 1.5rem;
    display: flex;
    align-items: center;
    flex-direction: column;

    border-radius: 1.5rem;
    background-color: #FFFFFF;
`;

export const ContainerDivider = styled.div` 
    width: 100%;
    height: auto;

    display: flex;
    align-items: center;
    justify-content: space-between;
`;

export const Divider = styled.div` 
    width: 100%;
    height: 0.0625rem;
    max-width: 11.875rem;

    background-color: #E9ECF0;
`;

export const ContainerButtonsAndTerms = styled.div` 
    width: 100%;
    height: auto;

    gap: 0.625rem;
    display: flex;
    align-items: center;
    flex-direction: column;

    >a >p{
        height: 3rem;
        width: 9.125rem;

        display: flex;
        cursor: pointer;
        align-items: center;
        justify-content: center;
    }

    @media (max-width: 767px) {
        gap: 0.75rem;

        >a >p{
            text-transform: uppercase;

            font-weight: 800;
            font-size: 0.625rem;
            letter-spacing: 0.1em;
            line-height: 0.9375rem;
        }
    }
`;

export const ContainerLogo = styled.div`
  width: 60%;

  display: flex;
  flex-direction: column;


  .logo{
    width: 100%;
  }

  .title{
    width: 100%;
    color: #FFF;
    font-family: Lato;
    font-weight: 700;
    font-style: normal;
    font-size: 28px;
    line-height: 33.6px;
  }

  .subtitle{
    width: 100%;
    color: #CED2DC;
    font-family: Lato;
    font-weight: 400;
    font-style: normal;
    font-size: 16px;
    line-height: 24px;
  }

  img {
    width: 120px;
    margin-bottom: 48px;
  }

  @media only screen and (max-width: 820px) {

    margin-bottom: 10px;

    .logo{
      width: 100%;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
    }

    .title{
      width: 100%;
      text-align: center;
    }

    .subtitle {
      width: 100%;
      text-align: center;
    }
  }

`;

export const ContainerForm = styled.div`
  width: 400px;
  height: auto;
  background-color: #FFF;
  position: static;
  top: calc(50% - 386px/2);
  border: 1px solid #FFF;
  border-radius: 8px;
  padding: 24px 32px;

  display: flex;
  flex-direction: column;
  align-items: center;

  .btnLinkedin{
    /* width: 242px; */
    width: 216px;
    height: auto;
    padding: 7px;
    display: flex;
    align-items: center;
    border: 1px solid #dbdde1;
    border-radius: 5px;
    cursor: pointer;
  }

  .iniciar{
    margin-left: 4px;
    -webkit-box-flex: 1;
    -webkit-flex-grow: 1;
    -ms-flex-positive: 1;
    flex-grow: 1;
    /* font-family: "Google Sans", arial, sans-serif; */
    font-size: 12.05px;
    letter-spacing: 0.25px;
    text-align: center;
    white-space: nowrap;
    color: #3c4043;
    font-weight: 500;
    overflow: hidden;
    /* text-overflow: ellipsis; */
    vertical-align: top;
  }

  .btnGoogle{
    width: auto;
    height: auto;
    padding: 5px;
    display: flex;
    align-items: center;
    border-radius: 5px;
    cursor: pointer;
  }

  @media only screen and (max-width: 820px) {
    /* padding: 10px; */

  }

  @media only screen and (max-width: 540px) {
    width: 90%;
  }
  
  @media only screen and (max-width: 460px) {
    width: 90%;
  }

  @media only screen and (max-width: 371px) {
    .box-end {
      .link {
        text-align: start;
      }
    }
  }

`;

export const Line = styled.div`
  width: 100%;
  height: 47px;
  padding-top: 5px;
  padding-bottom: 0px;

  hr {
    margin-top: 16px;
  }

  span {
    width: 16px;
    height: 15px;
    padding-left: 12px;
    padding-right: 12px;
    color: #000000;
    background-color: #FFF;
    font-family: Lato;
    font-style: normal;
    font-weight: bold;
    font-size: 10px;
    line-height: 150%;
    position: relative;
    top: -14px;
    left: calc(50% - 28px/2);
  }

`;

export const ContainerButtons = styled.div`
    width: 100%;
    height: auto;

    display: flex;
    justify-content: space-between;
`;

export const ContainerRegistration = styled.div`
    height: 2.5rem;
    width: 8.4375rem;

    display: flex;
    align-items: center;
    justify-content: center;

    >p{
        cursor: pointer;
    }

    @media (max-width: 767px) {
        >p{
            text-transform: uppercase;

            font-weight: 800;
            font-size: 0.625rem;
            letter-spacing: 0.1em;
            line-height: 0.9375rem;
        }
    }
`;

export const FormButton = styled.button`
    all: unset;

    width: auto;
    height: 1.5rem;
    padding: 0.75rem 2rem;

    gap: 0.75rem;
    display: flex;
    align-items: center;
    justify-content: center;

    cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};

    border-radius: 10rem;
    background-color: ${({ disabled }) => (disabled ? `${theme.colors.disabled.Fundo_Desabilitado}` : `${theme.colors.green.Verde_AgroReceita}`)}; 

    transition: background-color 0.3s ease, color 0.3s ease; 

    >p{
        cursor: ${({ disabled }) => (disabled ? "not-allowed" : "pointer")};

        color: ${({ disabled }) => (disabled ? '#AAAAAA' : '#FFFFFF')};
        
        transition: color 0.3s ease;
    }

    >img{
        height: auto;
        width: 1.25rem;

        transition: filter 0.3s ease; 
        filter: ${({ disabled }) => (disabled ? 'grayscale(100%)' : 'none')};
    }

    &:hover {
        background-color: ${({ disabled }) => (disabled ? `${theme.colors.disabled.Fundo_Desabilitado}` : '#259D57')}; 
    }
`;

export const ContainerInputsForm = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  .recover{
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    align-items: center;
    width: 100%;

    label{
      text-align: end;
      font-weight: 700;
      font-size: 14px;
      font-style: normal;
      color: #589BFF;
      cursor: pointer;
    }
  }


  .box-end{
    width: 100%;
    margin-top: 20px;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;

    a {
      text-decoration: none;
    }

    label{
      text-align: end;
      font-weight: 700;
      font-size: 14px;
      font-style: normal;
      color: #589BFF;
      cursor: pointer;
    }
  }


  
`;

export const Loading = styled.div`
  @-webkit-keyframes rotating /* Safari and Chrome */{
    from {
        -webkit-transform: rotate(0deg);
        -o-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    to {
        -webkit-transform: rotate(360deg);
        -o-transform: rotate(360deg);
        transform: rotate(360deg);
    }
  }
    
  @keyframes rotating {
    from {
        -ms-transform: rotate(0deg);
        -moz-transform: rotate(0deg);
        -webkit-transform: rotate(0deg);
        -o-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    to {
        -ms-transform: rotate(360deg);
        -moz-transform: rotate(360deg);
        -webkit-transform: rotate(360deg);
        -o-transform: rotate(360deg);
        transform: rotate(360deg);
    }
  }


  width: 20px;
  height: 20px;
  position: relative;
  margin: auto;

  background-color: transparent;

  border-top: 1px solid #FFFFFF;
  border-bottom: 1px solid #FFFFFF;
  border-left: 1px solid transparent;
  border-right: 1px solid transparent;
  border-radius: 50%;
  -webkit-animation: rotating 0.7s linear infinite;
  -moz-animation: rotating 0.7s linear infinite;
  -ms-animation: rotating 0.7s linear infinite;
  -o-animation: rotating 0.7s linear infinite;
  animation: rotating 0.7s linear infinite;
`;

export const ContainerModalRecover = styled.div`
    height: auto;
    width: 28.75rem;

    display: flex;
    align-items: center;
    flex-direction: column;

    >h3 {
        text-align: center;
    }

    >p {
        margin: 1.5rem 0;

        text-align: center;
    }

    @media (max-width: 767px) {
        width: 100%;

        >p{
            text-align: center;
        }
    }
`

export const FormRecover = styled.div`
    width: 100%;
    height: auto;

    gap: 1rem;
    display: flex;
    align-items: flex-end;
    flex-direction: column;
`

export const ContainerModalAccountNotFound = styled.div`
    height: auto;
    width: 28.75rem;

    display: flex;
    align-items: center;
    flex-direction: column;

    >h3 {
        text-align: center;
    }

    >p {
        margin: 1.5rem 0;

        text-align: center;
    }

    @media (max-width: 767px) {
        width: 100%;

        >p{
            text-align: center;
        }
    }
`

export const ContainerAccountNotFoundButtons = styled.div`
    width: 100%;
    height: auto;

    gap: 1rem;
    display: flex;
    align-items: center;
    justify-content: space-between;
`
export const TryAgainButton = styled.button`
    all: unset;

    width: 130px;
    height: 1.5rem;
    padding: 0.75rem 2rem;

    gap: 0.75rem;
    display: flex;
    align-items: center; 
    justify-content: center;

    cursor: pointer;

    border-radius: 10rem;
    border: 1px solid ${theme.colors.gray.Cinza_2};
    background-color: #FFFFFF; 

    transition: background-color 0.3s ease, color 0.3s ease; 

    >p{
        cursor: pointer;
        
        transition: color 0.3s ease;
    }

    >img{
        height: auto;
        width: 1.25rem;
    }
`;